"use client"
const FAQ = ({lang}) => { 
const faqs = document.querySelectorAll('[data-list="faq"]');
// console.log(faqs.length);

if(faqs.length != 0){
  faqs.forEach(function(faq,index){
    const items = faq.querySelectorAll(':scope > li');
    // console.log(items.length);
    const faqIndex = index;
    
    // Get all items
    items.forEach(function(item, index){
      // Set all variables
      const itemIndex = index;
      const input = item.querySelector(':scope > input');
      const type = input.getAttribute('type');
      const label = item.querySelector(':scope > label');
      const answer = item.querySelector(':scope > label + div');
      
      // Set aria control field
      label.setAttribute('aria-controls','faq-item-' + faqIndex + '-' + itemIndex);
      // Set answer ID
      answer.setAttribute('id','faq-item-' + faqIndex + '-' + itemIndex);
      // Set label as active tabindex
      // label.setAttribute('tabindex','0');
      
      // Set aria expanded depending on live 
      if(input.checked){
        // console.log('checked');
        label.setAttribute('aria-expanded','true');
      } else {
        // console.log('not');
        
      }
      
    });
    
    // Check if a FAQ is changed
    faq.addEventListener('change',function(e){
      const input = e.target;
      const item = e.target.parentNode;
      const label = e.target.nextElementSibling;
      const type = e.target.getAttribute('type');
      
      // Check if type is checkbox
      if(type == 'checkbox'){
        
        // console.log(label);
        if(input.checked){
          // console.log('checked');
          label.setAttribute('aria-expanded','true');
        } else {
          // console.log('not');
          label.setAttribute('aria-expanded','false');
        }
      }
      
      if(type == 'radio'){
        console.log(type);
      }
      
      
      
    });
  });
  
}

return (

<div itemScope itemType="https://schema.org/FAQPage">
  {/* <div className="py-10 px-4 container mx-auto">
    <h1 className="font-bold text-center text-xl mb-4">FAQ with automatic closing function (Radio button)</h1>
    <ul className="grid gap-6" data-list="faq">
      <li className="group" itemScope itemProp="mainEntity" itemType="https://schema.org/Question">
        <input className="peer/option-1 hidden" type="radio" id="option-1" name="options"/>
        <label className="peer-checked/option-1:bg-slate-900 peer-checked/option-1:text-white peer-checked/option-1:[&>svg]:rotate-45 block cursor-pointer p-4 pr-12 font-bold border border-slate-900 rounded transition-all duration-150 ease-in-out relative" htmlFor="option-1" itemProp="name">
          Option 1
          <svg className="block absolute top-1/2 right-4 -mt-[11.5px] transition-all duration-150 ease-in-out" width="22" height="23" viewBox="0 0 22 23" fill="none" xmlns="http://www.w3.org/2000/svg"><path d="M1 11.5L21 11.5" stroke="currentColor" strokeWidth="2" strokeLinecap="round"/><path d="M11 1.5L11 21.5" stroke="currentColor" strokeWidth="2" strokeLinecap="round"/></svg>
        </label>
        <div className="grid grid-rows-[0fr] transition-all duration-150 ease-in-out peer-checked/option-1:grid-rows-[1fr]" itemScope itemProp="acceptedAnswer" itemType="https://schema.org/Answer">
          <div className="min-h-[0px] overflow-hidden">
            <div className="mt-2 p-4 border border-slate-900 rounded" itemProp="text">Description 1 Lorem ipsum dolor sit amet consectetur adipisicing elit. Perspiciatis, laudantium.</div>
          </div>
        </div>
      </li>
      <li className="group" itemScope itemProp="mainEntity" itemType="https://schema.org/Question">
        <input className="peer/option-2 hidden" type="radio" id="option-2" name="options"/>
        <label className="peer-checked/option-2:bg-slate-900 peer-checked/option-2:text-white peer-checked/option-2:[&>svg]:rotate-45 block cursor-pointer p-4 pr-12 font-bold border border-slate-900 rounded transition-all duration-150 ease-in-out relative" htmlFor="option-2" itemProp="name">
          Option 2
          <svg className="block absolute top-1/2 right-4 -mt-[11.5px] transition-all duration-150 ease-in-out" width="22" height="23" viewBox="0 0 22 23" fill="none" xmlns="http://www.w3.org/2000/svg"><path d="M1 11.5L21 11.5" stroke="currentColor" strokeWidth="2" strokeLinecap="round"/><path d="M11 1.5L11 21.5" stroke="currentColor" strokeWidth="2" strokeLinecap="round"/></svg>
        </label>
        <div className="grid grid-rows-[0fr] transition-all duration-150 ease-in-out peer-checked/option-2:grid-rows-[1fr]" itemScope itemProp="acceptedAnswer" itemType="https://schema.org/Answer">
          <div className="min-h-[0px] overflow-hidden">
            <div className="mt-2 p-4 border border-slate-900 rounded" itemProp="text">Description 2 Lorem ipsum dolor sit amet consectetur adipisicing elit. Perspiciatis, laudantium.</div>
          </div>
        </div>
      </li>
      <li className="group" itemScope itemProp="mainEntity" itemType="https://schema.org/Question">
        <input className="peer/option-3 hidden" type="radio" id="option-3" name="options"/>
        <label className="peer-checked/option-3:bg-slate-900 peer-checked/option-3:text-white peer-checked/option-3:[&>svg]:rotate-45 block cursor-pointer p-4 pr-12 font-bold border border-slate-900 rounded transition-all duration-150 ease-in-out relative" htmlFor="option-3" itemProp="name">
          Option 3
          <svg className="block absolute top-1/2 right-4 -mt-[11.5px] transition-all duration-150 ease-in-out" width="22" height="23" viewBox="0 0 22 23" fill="none" xmlns="http://www.w3.org/2000/svg"><path d="M1 11.5L21 11.5" stroke="currentColor" strokeWidth="2" strokeLinecap="round"/><path d="M11 1.5L11 21.5" stroke="currentColor" strokeWidth="2" strokeLinecap="round"/></svg>
        </label>
        <div className="grid grid-rows-[0fr] transition-all duration-150 ease-in-out peer-checked/option-3:grid-rows-[1fr]" itemScope itemProp="acceptedAnswer" itemType="https://schema.org/Answer">
          <div className="min-h-[0px] overflow-hidden">
            <div className="mt-2 p-4 border border-slate-900 rounded" itemProp="text">Description 3 Lorem ipsum dolor sit amet consectetur adipisicing elit. Perspiciatis, laudantium.</div>
          </div>
        </div>
      </li>
      <li className="group" itemScope itemProp="mainEntity" itemType="https://schema.org/Question">
        <input className="peer/option-4 hidden" type="radio" id="option-4" name="options"/>
        <label className="peer-checked/option-4:bg-slate-900 peer-checked/option-4:text-white peer-checked/option-4:[&>svg]:rotate-45 block cursor-pointer p-4 pr-12 font-bold border border-slate-900 rounded transition-all duration-150 ease-in-out relative" htmlFor="option-4" itemProp="name">
          Option 4
          <svg className="block absolute top-1/2 right-4 -mt-[11.5px] transition-all duration-150 ease-in-out" width="22" height="23" viewBox="0 0 22 23" fill="none" xmlns="http://www.w3.org/2000/svg"><path d="M1 11.5L21 11.5" stroke="currentColor" strokeWidth="2" strokeLinecap="round"/><path d="M11 1.5L11 21.5" stroke="currentColor" strokeWidth="2" strokeLinecap="round"/></svg>
        </label>
        <div className="grid grid-rows-[0fr] transition-all duration-150 ease-in-out peer-checked/option-4:grid-rows-[1fr]" itemScope itemProp="acceptedAnswer" itemType="https://schema.org/Answer">
          <div className="min-h-[0px] overflow-hidden">
            <div className="mt-2 p-4 border border-slate-900 rounded" itemProp="text">Description 4 Lorem ipsum dolor sit amet consectetur adipisicing elit. Perspiciatis, laudantium.</div>
          </div>
        </div>
      </li>
    </ul>
  </div> */}

  <div className="py-10 px-4 container mx-auto">
    <h1 className="font-bold text-center text-4xl mb-4 font-montserrat dark:text-gray-200">FAQ</h1>
    <ul className="grid gap-6" data-list="faq">
      <li className="group" itemScope itemProp="mainEntity" itemType="https://schema.org/Question">
        <input className="peer/option-1 hidden" type="checkbox" id="checkbox-option-1" name="checkbox-options"/>
        <label className="peer-checked/option-1:bg-slate-900 peer-checked/option-1:text-white peer-checked/option-1:[&>svg]:rotate-45 block cursor-pointer p-4 pr-12 font-bold border border-slate-900 dark:border-gray-200 dark:text-gray-200 rounded transition-all duration-150 ease-in-out relative" htmlFor="checkbox-option-1" itemProp="name">
          {lang === 'fr' ? "Où sont hébérgées mes données ?" : "Where is my data hosted?"}
          <svg className="block absolute top-1/2 right-4 -mt-[11.5px] transition-all duration-150 ease-in-out" width="22" height="23" viewBox="0 0 22 23" fill="none" xmlns="http://www.w3.org/2000/svg"><path d="M1 11.5L21 11.5" stroke="currentColor" strokeWidth="2" strokeLinecap="round"/><path d="M11 1.5L11 21.5" stroke="currentColor" strokeWidth="2" strokeLinecap="round"/></svg>
        </label>
        <div className="grid grid-rows-[0fr] transition-all duration-150 ease-in-out peer-checked/option-1:grid-rows-[1fr]" itemScope itemProp="acceptedAnswer" itemType="https://schema.org/Answer">
          <div className="min-h-[0px] overflow-hidden">
            <div className="mt-2 p-4 border border-slate-900 dark:border-gray-200 dark:text-gray-200 rounded text-sm font-inter" itemProp="text">
               {lang === 'fr' ? "Nous sommes une entreprise canadienne qui n'a pas recours à de l'aide étrangère. Vos données sont traitées et hébérgées sur le sol canadien." : "We're a Canadian company that does not offshore. Your data is processed and hosted on canadian soil."}
            </div>
          </div>
        </div>
      </li>
      <li className="group" itemScope itemProp="mainEntity" itemType="https://schema.org/Question">
        <input className="peer/option-2 hidden" type="checkbox" id="checkbox-option-2" name="checkbox-options"/>
        <label className="peer-checked/option-2:bg-slate-900 peer-checked/option-2:text-white peer-checked/option-2:[&>svg]:rotate-45 block cursor-pointer p-4 pr-12 font-bold border border-slate-900 dark:border-gray-200 dark:text-gray-200 rounded transition-all duration-150 ease-in-out relative" htmlFor="checkbox-option-2" itemProp="name">
          {lang === 'fr' ? "Quels sont les coûts ?" : "How much does it cost?"}
          <svg className="block absolute top-1/2 right-4 -mt-[11.5px] transition-all duration-150 ease-in-out" width="22" height="23" viewBox="0 0 22 23" fill="none" xmlns="http://www.w3.org/2000/svg"><path d="M1 11.5L21 11.5" stroke="currentColor" strokeWidth="2" strokeLinecap="round"/><path d="M11 1.5L11 21.5" stroke="currentColor" strokeWidth="2" strokeLinecap="round"/></svg>
        </label>
        <div className="grid grid-rows-[0fr] transition-all duration-150 ease-in-out peer-checked/option-2:grid-rows-[1fr]" itemScope itemProp="acceptedAnswer" itemType="https://schema.org/Answer">
          <div className="min-h-[0px] overflow-hidden">
            <div className="mt-2 p-4 border border-slate-900 dark:border-gray-200 dark:text-gray-200 rounded text-sm font-inter" itemProp="text">{lang === 'fr' ? "Cette information est difficile à prévoir. Pour le moment, nous sommes concentrés à bâtir le meilleur produit possible." : "This information isn't available yet. For the moment, we're focused on building the best possible product."}</div>
          </div>
        </div>
      </li>
      {/* <li className="group" itemScope itemProp="mainEntity" itemType="https://schema.org/Question">
        <input className="peer/option-3 hidden" type="checkbox" id="checkbox-option-3" name="checkbox-options"/>
        <label className="peer-checked/option-3:bg-slate-900 peer-checked/option-3:text-white peer-checked/option-3:[&>svg]:rotate-45 block cursor-pointer p-4 pr-12 font-bold border border-slate-900 rounded transition-all duration-150 ease-in-out relative" htmlFor="checkbox-option-3" itemProp="name">
          Option 3
          <svg className="block absolute top-1/2 right-4 -mt-[11.5px] transition-all duration-150 ease-in-out" width="22" height="23" viewBox="0 0 22 23" fill="none" xmlns="http://www.w3.org/2000/svg"><path d="M1 11.5L21 11.5" stroke="currentColor" strokeWidth="2" strokeLinecap="round"/><path d="M11 1.5L11 21.5" stroke="currentColor" strokeWidth="2" strokeLinecap="round"/></svg>
        </label>
        <div className="grid grid-rows-[0fr] transition-all duration-150 ease-in-out peer-checked/option-3:grid-rows-[1fr]" itemScope itemProp="acceptedAnswer" itemType="https://schema.org/Answer">
          <div className="min-h-[0px] overflow-hidden">
            <div className="mt-2 p-4 border border-slate-900 rounded" itemProp="text">Description 3 Lorem ipsum dolor sit amet consectetur adipisicing elit. Perspiciatis, laudantium.</div>
          </div>
        </div>
      </li>
      <li className="group" itemScope itemProp="mainEntity" itemType="https://schema.org/Question">
        <input className="peer/option-4 hidden" type="checkbox" id="checkbox-option-4" name="checkbox-options"/>
        <label className="peer-checked/option-4:bg-slate-900 peer-checked/option-4:text-white peer-checked/option-4:[&>svg]:rotate-45 block cursor-pointer p-4 pr-12 font-bold border border-slate-900 rounded transition-all duration-150 ease-in-out relative" htmlFor="checkbox-option-4" itemProp="name">
          Option 4
          <svg className="block absolute top-1/2 right-4 -mt-[11.5px] transition-all duration-150 ease-in-out" width="22" height="23" viewBox="0 0 22 23" fill="none" xmlns="http://www.w3.org/2000/svg"><path d="M1 11.5L21 11.5" stroke="currentColor" strokeWidth="2" strokeLinecap="round"/><path d="M11 1.5L11 21.5" stroke="currentColor" strokeWidth="2" strokeLinecap="round"/></svg>
        </label>
        <div className="grid grid-rows-[0fr] transition-all duration-150 ease-in-out peer-checked/option-4:grid-rows-[1fr]" itemScope itemProp="acceptedAnswer" itemType="https://schema.org/Answer">
          <div className="min-h-[0px] overflow-hidden">
            <div className="mt-2 p-4 border border-slate-900 rounded" itemProp="text">Description 4 Lorem ipsum dolor sit amet consectetur adipisicing elit. Perspiciatis, laudantium.</div>
          </div>
        </div>
      </li> */}
    </ul>
  </div>
</div>
)
}

export default FAQ